import { ContainerSize, Team } from '@lib/types';
import Container from '@components/container';
import Image from '@components/image';

export type TeamProps = {
  data: Team;
};

export default function TeamSection({
  data: { title, lead, employees },
}: TeamProps) {
  return (
    <Container size={ContainerSize.wide}>
      <div className="grid grid-cols-12 gap-1.5 md:gap-6">
        <div className="col-start-2 col-span-11 md:col-start-4 md:col-span-6">
          <h2 className="font-bold text-22 leading-135 md:text-25 md:leading-140 text-blue-800 mb-6">
            {title}
          </h2>
          <div
            className="prose mb-8 md:mb-16"
            dangerouslySetInnerHTML={{ __html: lead }}
          />
        </div>
      </div>
      <div className="grid grid-cols-12 gap-1.5 md:gap-6 gap-y-12">
        {employees &&
          employees.map((employee) => (
            <div key={employee.id} className="col-span-12 md:col-span-4">
              <div className="w-full aspect-w-4 aspect-h-3 md:aspect-w-16 md:aspect-h-12 rounded-xl md:rounded-3xl mb-6 bg-[#D9D9D9]">
                {employee.portrait && (
                  <div className="absolute inset-0">
                    <Image
                      className={`h-full w-full object-cover bg-center bg-cover rounded-xl md:rounded-3xl`}
                      src={employee.portrait}
                      height={employee.portrait.height}
                      width={employee.portrait.width}
                      alt={employee.portrait.alternativeText}
                      sizes="(max-width: 768px) 100vw,33vw"
                    />
                  </div>
                )}
              </div>
              <div className="grid md:block grid-cols-12 ">
                <div className="col-start-2 col-span-11 md:col-start-1 md:col-span-12">
                  <h3 className="text-17 leading-140 tracking-2 font-bold text-blue-800 mb-4">
                    {employee.titlesSalutation} {employee.firstName}{' '}
                    {employee.middleName} {employee.lastName} {employee.suffix}
                    {employee.linkedIn && (
                      <a
                        href={employee.linkedIn}
                        target="_blank"
                        rel="noreferrer">
                        <img
                          className="inline ml-2 relative top-[-4px]"
                          src="/linkedIn.svg"
                          width={18}
                          height={18}
                        />
                      </a>
                    )}
                  </h3>
                  <p className="text-17 leading-160">{employee.description}</p>
                  {employee.bio && (
                    <div
                      className="prose bio mt-2 md:mt-4"
                      dangerouslySetInnerHTML={{ __html: employee.bio }}
                    />
                  )}
                </div>
              </div>
            </div>
          ))}
      </div>
    </Container>
  );
}
